import React, { createContext, ReactNode, useContext, useState } from 'react';


// Define the context type
interface ThemeContextType {
  headerColor: string;
  setHeaderColor: (color: string) => void;
  headerTextColor: string;
  setHeaderTextColor: (color: string) => void;
  headerButtonColor: string;
  setHeaderButtonColor: (color: string) => void;
  headerButtonTextColor: string;
  setHeaderButtonTextColor: (color: string) => void;
  contentBackgroundColor: string;
  setContentBackgroundColor: (color: string) => void;
  contentTitleColor: string;
  setContentTitleColor: (color: string) => void;
  contentTextColor: string;
  setContentTextColor: (color: string) => void;
  contentButtonColor: string;
  setContentButtonColor: (color: string) => void;
  contentButtonTextColor: string;
  setContentButtonTextColor: (color: string) => void;
  footerBackgroundColor: string;
  setFooterBackgroundColor: (color: string) => void;
  footerTextColor: string;
  setFooterTextColor: (color: string) => void;
  footerButtonColor: string;
  setFooterButtonColor: (color: string) => void;
  footerButtonTextColor: string;
  setFooterButtonTextColor: (color: string) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

    export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [headerColor, setHeaderColor] = useState("#1175a2");
  const [headerTextColor, setHeaderTextColor] = useState("#fff");
  const [headerButtonColor, setHeaderButtonColor] = useState("#b30700");
  const [headerButtonTextColor, setHeaderButtonTextColor] = useState("#fff");

  const [contentBackgroundColor, setContentBackgroundColor] = useState("#fbfbfb");
  const [contentTitleColor, setContentTitleColor] = useState("#004997");
  const [contentTextColor, setContentTextColor] = useState("#000");
  const [contentButtonColor, setContentButtonColor] = useState("#4a96b8");
  const [contentButtonTextColor, setContentButtonTextColor] = useState("#fff");

  const [footerBackgroundColor, setFooterBackgroundColor] = useState("#ddd");
  const [footerTextColor, setFooterTextColor] = useState("#000");
  const [footerButtonColor, setFooterButtonColor] = useState("#000");
  const [footerButtonTextColor, setFooterButtonTextColor] = useState("#000");

  return (
    <ThemeContext.Provider value={{ headerColor,setHeaderColor, headerTextColor, setHeaderTextColor, headerButtonColor, setHeaderButtonColor,
      headerButtonTextColor, setHeaderButtonTextColor, contentBackgroundColor, setContentBackgroundColor, contentTitleColor, setContentTitleColor,
      contentTextColor, setContentTextColor, contentButtonColor, setContentButtonColor,contentButtonTextColor, setContentButtonTextColor,
      footerBackgroundColor, setFooterBackgroundColor, footerTextColor, setFooterTextColor, footerButtonColor, setFooterButtonColor, footerButtonTextColor, setFooterButtonTextColor
      
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
export const useThemeContextChange = () => {
    
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('Contect Error');
    }
    return context;
};


